/** One catalogue owns each challenge's rules, labels and scoring direction. */
export const measuredActivities = {
  "closest-to-pin": {
    label: "Closest to the pin",
    scoring: "closest",
    category: "Precision",
    instruction:
      "Agree a tee and target green. Measure from the resting ball to the hole; only balls on the agreed green count.",
  },
  "longest-drive": {
    label: "Longest drive",
    scoring: "longest",
    category: "Distance",
    instruction:
      "Use the same tee and landing area. Agree carry or total distance; the longest valid drive wins.",
  },
  putting: {
    label: "Putting",
    scoring: "count",
    category: "Short game",
    instruction:
      "Agree the putting spots and give everyone the same attempts. Count holed putts; most made wins.",
  },
  chipping: {
    label: "Chipping closest",
    scoring: "closest",
    category: "Short game",
    instruction:
      "Chip from the same agreed spot. Measure the resting ball's distance to the hole; balls outside the agreed green are misses.",
  },
  "chip-target": {
    label: "Chip Target",
    scoring: "count",
    category: "Short game",
    instruction:
      "Chip from the same spot into an agreed target zone. Record Hit or Miss; most hits wins.",
  },
  "bunker-shot": {
    label: "Bunker challenge",
    scoring: "closest",
    category: "Short game",
    instruction:
      "Play from equivalent lies in the same bunker. Closest to the hole on the agreed green wins; a ball left in the bunker is a miss.",
  },
  "straightest-drive": {
    label: "Straightest drive",
    scoring: "closest",
    category: "Precision",
    instruction:
      "Mark a centre line and agree a minimum drive distance. Measure sideways from the resting ball to the line. Short or out-of-bounds drives are misses.",
  },
  "longest-putt": {
    label: "Longest putt",
    scoring: "longest",
    category: "Short game",
    instruction:
      "Agree a hole and number of attempts. Record the starting distance of each holed putt; the longest holed putt wins.",
  },
  "target-hits": {
    label: "Target hits",
    scoring: "count",
    category: "Precision",
    instruction:
      "Agree a target zone and the same shots for everyone. Count balls that finish inside the zone; most hits wins.",
  },
  "up-and-down": {
    label: "Up-and-down",
    scoring: "count",
    category: "Short game",
    instruction:
      "Agree the same short-game spots. Each attempt is a chip or bunker shot followed by putting. Hole out in two strokes or fewer for one success.",
  },
} as const;

export type MeasuredActivity = keyof typeof measuredActivities;
export const measuredActivityIds = Object.keys(
  measuredActivities,
) as MeasuredActivity[];
export function isCountChallenge(activity: MeasuredActivity): boolean {
  return measuredActivities[activity].scoring === "count";
}
export function isClosestChallenge(activity: MeasuredActivity): boolean {
  return measuredActivities[activity].scoring === "closest";
}
export function challengeSuccessLabel(activity: MeasuredActivity): string {
  return activity === "putting"
    ? "Made"
    : activity === "target-hits" || activity === "chip-target"
      ? "Hit"
      : "Success";
}
export function challengeCountUnit(
  activity: MeasuredActivity,
): "made-putts" | "successes" {
  return activity === "putting" ? "made-putts" : "successes";
}
